module.exports = __webpack_public_path__ + "img/adhesivo_para_piedras_naturales_de_baja_absorcion.d1df5a07.png";